export default "__VITE_ASSET__BPmDKhdz__"